import { Component, input, output, signal, computed, effect, inject } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { Location } from '../../models/classes/location';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NavButtonComponent } from '../nav-button/nav-button';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { RenameCardHeaderComponent } from './rename-card-header/rename-card-header';

@Component({
  selector: 'app-card',
  imports: [
    RenameCardHeaderComponent,
    NzCardModule,
    NzIconModule,
    NavButtonComponent,
    NzAvatarModule,
  ],
  templateUrl: './card.html',
  styleUrls: ['./card.scss'],
})
export class CardComponent {
  // Inputs using Angular 20 signals
  plant = input<Location | null>(null);
  parentArray = input<Location[]>([]);
  fine = input<boolean>(false);
  modal = input<boolean>(false);
  detail = input<boolean>(false);
  closeBtn = input<boolean>(false);
  renameBtn = input<boolean>(false);
  isEditable = input<boolean>(false);
  editObject = input<any>(null);

  //Outputs using Angular 20 signals
  closed = output<void>();
  nav = output<void>();
  delete = output<Location>();
  nameError = output<boolean>();
  editCompleted = output<void>();

  // Inject services
  public i18n = inject(I18nService);
  private ui = inject(UiService);

  // Local signals
  defaultImage = signal<string>('assets/images/plant_default_picture.png');

  // Computed signals
  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());
  isDesktop = computed(() => this.ui.IsDesktop());

  // Effects
  constructor() {
    effect(() => {
      if (this.plant()) {
        this.getSensorCount();
      }
    });
  }

  // Methods
  getSensorCount(): number {
    const plant = this.plant();
    if (!plant) return 0;
    const sensors = plant.Assets.map((plant) => (plant.sensors ? plant.sensors : [])).flat(1);
    return sensors.length;
  }

  onNav() {
    this.nav.emit();
  }
  OnEditComplete() {
    this.editCompleted.emit();
  }

  onDelete(location: Location) {
    if (this.plant()) {
      this.delete.emit(location);
    }
  }

  onNameError(event: boolean) {
    this.nameError.emit(event);
  }
}
